import { Divider, Tooltip } from "antd"
import { getInitials } from "./TimeSheetActivityRow"
import { IShiftSwapsDocsEntity } from "../typings"
import { toast } from "react-toastify"
import useCopyToClipboard from "hooks/useCopyToClipboard"
import { formatDateReadable } from "utils/formatDate"
import dayjs from "dayjs"

interface ShiftActivityRowProps {
  requesterEmployee: string
  targetEmployee: string
  requesterShiftPlan: string
  targetShiftPlan: string
  requesterStartPeriod: string
  targetEndPeriod: string
  shiftPeriod: string
  requestershiftPeriod: string
  targeteshiftPeriod: string
  targetStartPeriod: string
  requesterEndPeriod: string
  requesterReason?: string
  targetReason?: string
  targetDepartment?: string
  requesterDepartment?: string
  shiftSwap: IShiftSwapsDocsEntity
}

const subRowGridClass =
  "grid grid-cols-[160.67px_160.67px_160.67px_160.67px_160.67px_160.67px] h-[144px] gap-3 items-center py-3"

const ShiftSwapActivityRow = ({
  shiftSwap,
  requesterEmployee,
  targetEmployee,
  requesterShiftPlan,
  targetShiftPlan,
  requestershiftPeriod,
  targeteshiftPeriod,
  requesterStartPeriod,
  targetStartPeriod,
  requesterEndPeriod,
  targetEndPeriod,
  requesterReason,
  targetReason,
  targetDepartment,
  requesterDepartment,
}: ShiftActivityRowProps) => {
  const [_, copy] = useCopyToClipboard()

  return (
    <div className="py-1">
      {/* REQUESTER ROW */}
      <div className={subRowGridClass}>
        {/* User */}
        <div className="flex items-center gap-2 shrink-0 px-4 text-slate-950 text-sm">
          <span className="rounded-full h-10 w-10 flex shrink-0 items-center justify-center bg-[#E2E8F0] p-1 font-semibold text-sm">
            {getInitials(requesterEmployee)}
          </span>
          <p className="truncate min-w-0">{requesterEmployee}</p>
        </div>
        {/* Shift Plan */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm capitalize">
          {requesterShiftPlan}
        </p>
        {/* Department */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm">
          {requesterDepartment}
        </p>
        {/* Shift Period */}
        <div className="min-w-0 flex flex-col text-sm capitalize px-4">
          <span className="font-semibold text-slate-900 pb-1 truncate">
            {requestershiftPeriod}
          </span>
          <div className="flex flex-col text-slate-400 text-xs border-l border-l-slate-400 pl-1">
            <span>{requesterStartPeriod}</span>
            <span>{requesterEndPeriod}</span>
          </div>
        </div>
        {/* Shift Date */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm capitalize">
          {formatDateReadable(
            shiftSwap?.sourceShiftAssignment?.createdDate ||
              dayjs().toISOString()
          )}
        </p>
        {/* Reason */}
        <div className="flex items-center px-4 min-w-0">
          <Tooltip title={requesterReason}>
            <p className="line-clamp-3 overflow-hidden text-sm text-slate-950">
              {requesterReason || "—"}
            </p>
          </Tooltip>
        </div>
      </div>

      <Divider
        className="bg-gray-100"
        style={{ margin: "4px 0" }}
      />

      {/* TARGET ROW */}
      <div className={subRowGridClass}>
        {/* User */}
        <div className="flex items-center gap-2 shrink-0 px-4 text-slate-950 text-sm">
          <span className="rounded-full h-10 w-10 flex shrink-0 items-center justify-center bg-[#E2E8F0] p-1 font-semibold text-sm">
            {getInitials(targetEmployee)}
          </span>
          <p className="truncate min-w-0">{targetEmployee}</p>
        </div>
        {/* Shift Plan */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm capitalize">
          {targetShiftPlan}
        </p>
        {/* Department */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm">
          {targetDepartment}
        </p>
        {/* Shift Period */}
        <div className="min-w-0 flex flex-col text-sm capitalize px-4">
          <span className="font-semibold text-slate-900 pb-1 truncate">
            {targeteshiftPeriod}
          </span>
          <div className="flex flex-col text-slate-400 text-xs border-l border-l-slate-400 pl-1">
            <span>{targetStartPeriod}</span>
            <span>{targetEndPeriod}</span>
          </div>
        </div>
        {/* Shift Date */}
        <p className="min-w-0 line-clamp-2 px-4 flex items-center text-slate-950 text-sm capitalize">
          {formatDateReadable(
            shiftSwap?.targetShiftAssignment?.createdDate ||
              dayjs().toISOString()
          )}
        </p>
        {/* Reason */}
        <div className="flex items-center px-4 min-w-0">
          <Tooltip title={targetReason}>
            <p className="line-clamp-3 overflow-hidden text-sm text-slate-950">
              {targetReason || "—"}
            </p>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default ShiftSwapActivityRow
